import { QuoteInfo } from "./QuoteInfo";
import { QuoteInsurance } from "./QuoteInsurance";
import { Checkout } from "./Checkout";
import { InsuranceAddress } from "./InsuranceAddress";
import { Defaults } from "./Defaults";

export class Quote {
  address = new InsuranceAddress();
  info = new QuoteInfo();
  rentersInsurance = new QuoteInsurance();
  personalInsurance = new QuoteInsurance();
  hasPersonalInsurance: boolean | undefined = undefined;
  checkout = new Checkout();
  processingFee = 0;
  monthlyProcessingFee = 0;
  done = false;
  nssiPassed = false;
  assurantPassed = false;
  assurantToken = "";
  assurantExpirationTime = "";
  currentStep = "";
  showAddressHelp = false;
  assurantPolicyError = "";
  nssiPolicyError = "";
  showAddonOnCart = false;
  folowUpMailSent = false;
  value: any;
  denialNotice = "";
  responseMessage = "";
}
